import React from 'react';
import styled from 'styled-components';

type Props = {
  children?: React.ReactNode,
};
const Contents = ({children}: Props) => (
  <StyledContents>{children}</StyledContents>
);

export default Contents;

const StyledContents = styled.div`
  text-align: left;
`;
